import type { FormEvent } from "react";

import { Button, Input } from "@/atoms";
import { strings } from "@/constants";
import { ButtonTypeEnum, ButtonVariantEnum, InputTypeEnum } from "@/enums";

export const ForgotPasswordForm = ({
    email,
    error,
    isLoading,
    onBackToLogin,
    onChangeEmail,
    onSubmit,
}: {
    email: string,
    error: string,
    isLoading: boolean,
    onBackToLogin: () => void,
    onChangeEmail: (value: string) => void,
    onSubmit: (event: FormEvent<HTMLFormElement>) => void,
}) => (
    <>
        <form
            className="space-y-5"
            onSubmit={onSubmit}
        >
            <Input
                hasError={!!error}
                label={strings.forgotPassword.emailLabel}
                placeholder={strings.forgotPassword.emailPlaceholder}
                type={InputTypeEnum.EMAIL}
                value={email}
                onChange={({ target }) => onChangeEmail(target.value)}
            />
            <Button
                isLoading={isLoading}
                type={ButtonTypeEnum.SUBMIT}
                isFullWidth
            >
                {strings.forgotPassword.submitButton}
            </Button>
        </form>
        <div className="mt-4 text-center">
            <Button
                variant={ButtonVariantEnum.LINK}
                onClick={onBackToLogin}
            >
                {strings.forgotPassword.backToLogin}
            </Button>
        </div>
    </>
);
